export const charityName = "CYRENAEUS";
